import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/style.css'
Vue.use(ElementUI)

// 全局引用Header组件
import myHeader from './components/myHeader'
Vue.use(myHeader)
// 全局引用Footer组件
import myFooter from './components/myFooter'
Vue.use(myFooter)
//全局引用时间选择组件
import timePiker from './components/timepiker'
Vue.use(timePiker)
// 全局引用examinationSidebar组件
import examinationSidebar from './components/examinationSidebar'
Vue.use(examinationSidebar)
// 全局引用examinationSidebar组件
import centerMenu from './components/centerMenu'
Vue.use(centerMenu)
// 高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader();

import htmlToPdf from "../src/utils/htmlToPdf"
Vue.use(htmlToPdf)

// 全局过滤器
import * as filters from './filters'
Vue.prototype.$filters = filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

window.vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')


